import { useLayoutEffect } from "react";

import { AdapexAds } from "../adapex-ads.component";
import { ArcadeHeader } from "../arcade-header/arcade-header.component";

const enable_quiz_ads = window.FKL.enable_quiz_ads;
const show_adapex_ads =
  window.FKL.show_adapex_ads?.toLocaleLowerCase() === "true";

export const ArcadeShield = ({
  className,
  roundIndex,
  header,
  children,
}: {
  className: string;
  roundIndex: number;
  header: React.ComponentProps<typeof ArcadeHeader>;
  children: React.ReactNode;
}) => {
  useLayoutEffect(() => {
    const mainContent = document.querySelector(
      ".main-content"
    ) as HTMLElement | null;
    if (mainContent) mainContent.style.paddingTop = "0px";

    const container = document.querySelector(
      ".product-template__container"
    ) as HTMLElement;
    if (container) container.classList.remove("page-width");
  }, []);

  const arcadeBottomAds = (() => {
    const updateMobileBottomAdsStyleOnRoundChange = (): string =>
      [
        "mobile",
        (roundIndex + 1) % 3 === 0 ? "fixedHeight" : "fixedShortHeight",
      ].join(" ");

    return (
      <div className="arcade__ads--bottom">
        <div className="desktop">
          {(roundIndex + 1) % 3 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_728v_1" />
          ) : (roundIndex + 1) % 2 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_728v_2" />
          ) : (roundIndex + 1) % 1 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_728v_3" />
          ) : null}
        </div>

        <div className={updateMobileBottomAdsStyleOnRoundChange()}>
          {(roundIndex + 1) % 3 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_MOB_300v_1" />
          ) : (roundIndex + 1) % 2 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_MOB_300v_2" />
          ) : (roundIndex + 1) % 1 === 0 ? (
            <AdapexAds key={roundIndex} adunit="fkl_MOB_300v_3" />
          ) : null}
        </div>
      </div>
    );
  })();

  return (
    <>
      <ArcadeHeader {...header} />
      <div
        className="arcade__shield"
      >
        {enable_quiz_ads && show_adapex_ads ? (
          <>
            <div className="arcade__ads--left">
              <AdapexAds adunit="fkl_300v_Sticky_Left" />
            </div>
            <div
              className={["arcade__main", className].filter(Boolean).join(" ")}
            >
              {children}
            </div>
            <div className="arcade__ads--right">
              <AdapexAds adunit="fkl_300v_Sticky" />
            </div>
            {arcadeBottomAds}
          </>
        ) : (
          <div
            className={["arcade__main", className].filter(Boolean).join(" ")}
          >
            {children}
          </div>
        )}
      </div>
    </>
  );
};
